import { render, staticRenderFns } from "./homeBotton.vue?vue&type=template&id=4d8c2f4a&scoped=true&"
import script from "./homeBotton.vue?vue&type=script&lang=js&"
export * from "./homeBotton.vue?vue&type=script&lang=js&"
import style0 from "./homeBotton.vue?vue&type=style&index=0&id=4d8c2f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c2f4a",
  null
  
)

export default component.exports